module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/200M超高画素AFカメラ.ac3ed217.png";